import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LinePaperclipIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m18.08 12.42-6.18 6.19a4.25 4.25 0 0 1-6-6l8-8a2.5699 2.5699 0 0 1 3.54 0 2.5198 2.5198 0 0 1 0 3.54l-6.9 6.89a.765.765 0 0 1-.5317.2437.7654.7654 0 0 1-.5483-.2037.7646.7646 0 0 1-.1964-.8261A.7636.7636 0 0 1 9.42 14l5.13-5.12a1.0041 1.0041 0 1 0-1.42-1.42L8 12.6a2.74 2.74 0 0 0 0 3.89 2.82 2.82 0 0 0 3.89 0l6.89-6.9a4.5003 4.5003 0 0 0-.1103-6.2497A4.4999 4.4999 0 0 0 12.42 3.23l-8 8A6.25 6.25 0 0 0 13.31 20l6.19-6.18a1.0044 1.0044 0 0 0 .2177-1.0943 1.005 1.005 0 0 0-.5434-.5434 1.0056 1.0056 0 0 0-.7685 0 1.0044 1.0044 0 0 0-.3258.2177v.02Z"/>
  </SvgIcon>
}

export default LinePaperclipIcon
